import React from 'react'

export function OrderLoading() {
  return <div></div>
}